<template>
  <div class="keySpace">
       特色空间
  </div>
</template>
<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'
export default {
  name: 'keySpace',
  data () {
    return {
      intro: {},
      durationList: [],
      picList: [],
      lan: this.$store.state.isEn,
      articleTypeId: 9
    }
  },
  watch: {
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
      this.init()
    }
  },
  mounted () {
  },
  activated () {
  },
  methods: {
  }
}
</script>
<style scoped>

</style>
